import { LiaCheckCircleSolid } from "react-icons/lia";
import { Link } from "react-router-dom";


function ThanksPage() {
  return (
    <div className="thanks-page h-screen flex flex-col items-center justify-center text-center p-4  ">
      <div className=" flex flex-col justify-center items-center pt-20 space-y-6">

                     <div className="space-y-1">
                     <LiaCheckCircleSolid color="#DF73FF"  className="mx-auto text-7xl md:text-8xl"/>

                     <h2 className="text-[#DF73FF] font-bold text-4xl  md:text-6xl">Thank you! </h2>
                     <p className="text-dark text-lg md:text-xl">Our team will be in touch shortly.</p>
                     </div>
      
        <Link
                to="/" 
                className=" px-3 md:px-6 py-[10px] md:py-[14px] bg-[#FFC067] text-dark font-bold rounded shadow  transition  text-base md:text-lg   hover-filled  inline  mt-6"
                >
                Back to Home
              </Link>
                </div> 
    </div>
  );
}

export default ThanksPage;